import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

import GeoCoordinates from './GeoCoordinates';
import MicrodataHTMLAttributes from './MicrodataHTMLAttributes';
import schema from './schema';

type Props = Pick<SeoLocation, 'localityType' | 'details'> & MicrodataHTMLAttributes;

const CityOrPlace: React.FC<Props> = ({ localityType, details, ...props }: Props) => {
  const { locality } = details;
  return (
    <A11yHiddenBox
      {...props}
      webProps={{
        itemScope: true,
        itemType: localityType === 'city' ? schema`City` : schema`Place`,
      }}
    >
      <meta itemProp="name" content={locality.seoDisplayName} />
      <GeoCoordinates itemProp="geo" {...locality} />
    </A11yHiddenBox>
  );
};

export default CityOrPlace;
